<script>
export default {
  props: {
    letter: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '1x',
    },
  },

  computed: {
    isLetters() {
      return this.letter.toLowerCase().match(/[a-z]/i) !== null;
    },

    className() {
      if (this.isLetters) {
        return 'fa-solid fa-square-' + this.letter.toLowerCase() + ' fa-' + this.size;
      }
      return 'fa-solid fa-square' + ' fa-' + this.size;
    },
  },
};
</script>

<template>
  <i v-if="isLetters" :class="className" class="icon-letters icons" />
  <span v-else class="non-letter" :class="'fa-' + size">{{ letter }}</span>
</template>
